import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S2};
  padding: ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  ${getShadow('raisedLight', { borderColor: Color.Purple200, color: Color.Purple800 })};

  svg {
    flex-shrink: 0;
  }
`
